import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import styles from './partList.module.css';
import { Close } from "../../../../Svg";
import { useDispatch } from "react-redux";
import { deletBomPreviewData, deleteInputValue, sendBomEnquiryThunk } from "../../../redux/bomSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const PartList = ({ data, deleteProduct }) => {

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()


  const getBreakQtyDetails = (quantityTable, quantity) => {
    if (!Array.isArray(quantityTable) || quantityTable.length === 0) {
      return { breakQty: 1, unitPrice: 0 };
    }
    const sortedTable = [...quantityTable]?.sort((a, b) => (a?.breakQty || 0) - (b?.breakQty || 0));
    return sortedTable.find((entry) => quantity <= entry?.breakQty) || sortedTable[sortedTable.length - 1] || { breakQty: 1, unitPrice: 0 };
  };

  const calculateTotal = () => {
    return data?.reduce((total, product) => {

      const priceDetails = getBreakQtyDetails(product.product?.quantityTable, product.quantity);

      const unitPrice = priceDetails ? priceDetails.unitPrice : 0;

      return total + product.quantity * unitPrice;
    }, 0);
  };





  const partList = data?.map(i => (
    {
      productNumber: i?.productNumber,
      quantity: i?.quantity,
      manufacturer: i?.product?.productOverview?.manufacturer[0]?.name || i?.manufacturer,
      _id: i?.product?._id
    }
  ))

  console.log(data);
  console.log(calculateTotal(),);


  const formik = useFormik({
    initialValues: {
      partList: partList,
      total: calculateTotal(),
      projectName: "",
      application: "",
      annualVolume: "",
      endCustomer: "",
      enquiryType: "",
      sop: "",
    },
    validationSchema: Yup.object({
      // projectName: Yup.string().required("Required"),
      application: Yup.string().required("Required"),
      annualVolume: Yup.string().required("Required"),
      // endCustomer: Yup.string().required("Required"),
      enquiryType: Yup.string().required("Required"),
      sop: Yup.string().required("Required"),
    }),
    onSubmit: async (values) => {
      console.log("Form Data:", values);
      setLoading(true)
      if (data?.length <= 0) {
        setLoading(false)
        return toast.error('min one product is required')
      }
      const status = await dispatch(sendBomEnquiryThunk(values))
      if (status.payload == 200) {
        dispatch(deletBomPreviewData())
        dispatch(deleteInputValue())
        navigate('/bomManage')
      }

      setLoading(false)
    },
  });





  return (
    <>
      <div className={styles.previewContainer}>
        <p>Please fill out the quote request form below and an Electrowiz representative will contact you shortly.</p>
        <span className={styles.previewTitle}>Part List</span>
        <div className={styles.hrLine}></div>

        <div className={styles.previewContainerScroll}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth}>Sl No</th>
                <th className={styles.previewth}>Manufacture Part #</th>
                <th className={styles.previewth}>Quantity</th>
                <th className={styles.previewth}>Manufacture/Purchase Order #</th>
                <th className={styles.previewth}></th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => {
                const { breakQty, unitPrice } = getBreakQtyDetails(
                  item.product?.quantityTable,
                  item.quantity
                );
                return (
                  <tr key={item.id} className={styles.previewstripedRow}>
                    <td className={styles.previewtd}>{index + 1}</td>
                    <td className={styles.previewtd}>{item?.productNumber}</td>
                    <td className={styles.previewtd}>{item?.quantity}</td>
                    {/* <td className={styles.previewtd}>{unitPrice || 0}</td>
                    <td className={styles.previewtd}>{breakQty || 0}</td> */}
                    <td className={styles.previewtd}>{item?.product?.productOverview?.manufacturer[0]?.name || item?.manufacturer}</td>
                    <td className={styles.previewtd} onClick={() => deleteProduct(item?.productNumber)} style={{ cursor: 'pointer' }}>
                      <Close />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <form onSubmit={formik.handleSubmit} className={styles.qrForm}>
          <span className={styles.previewTitle}>Quote Request Form</span>
          <div className={styles.hrLine}></div>
          <div className={styles.qrForminputMain}>
            <div className={styles.qrForminputs}>
              <div className={styles.loginInputGroup}>
                <label>Project Name</label>
                <input
                  type="text"
                  name="projectName"
                  placeholder="Enter"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.projectName}
                />
                {formik.touched.projectName && formik.errors.projectName ? (
                  <div className={styles.errorText}>{formik.errors.projectName}</div>
                ) : null}
              </div>

              <div className={styles.loginInputGroup}>
                <label>Application<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="application"
                  placeholder="Enter"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.application}
                />
                {formik.touched.application && formik.errors.application ? (
                  <div className={styles.errorText}>{formik.errors.application}</div>
                ) : null}
              </div>

              <div className={styles.loginInputGroup}>
                <label>Annual Volume<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="annualVolume"
                  placeholder="Enter"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.annualVolume}
                />
                {formik.touched.annualVolume && formik.errors.annualVolume ? (
                  <div className={styles.errorText}>{formik.errors.annualVolume}</div>
                ) : null}
              </div>
            </div>

            <div className={styles.qrForminputs}>
              <div className={styles.loginInputGroup}>
                <label>End Customer</label>
                <input
                  type="text"
                  name="endCustomer"
                  placeholder="Enter"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.endCustomer}
                />
                {formik.touched.endCustomer && formik.errors.endCustomer ? (
                  <div className={styles.errorText}>{formik.errors.endCustomer}</div>
                ) : null}
              </div>

              <div className={styles.loginInputGroup}>
                <label>Bidding/Buying<span style={{ color: 'red' }}>*</span></label>
                <select
                  name="enquiryType"
                  className={styles.selectField}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.enquiryType}
                >
                  <option value="">Select</option>
                  <option value="BIDDING">BIDDING</option>
                  <option value="BUYING">BUYING</option>
                </select>
                {formik.touched.enquiryType && formik.errors.enquiryType ? (
                  <div className={styles.errorText}>{formik.errors.enquiryType}</div>
                ) : null}
              </div>

              <div className={styles.loginInputGroup}>
                <label>SOP(start of production)<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  name="sop"
                  placeholder="mm/yyyyy"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.sop}
                />
                {formik.touched.sop && formik.errors.sop ? (
                  <div className={styles.errorText}>{formik.errors.sop}</div>
                ) : null}
              </div>
            </div>
          </div>
          <div className={styles.hrLine}></div>

          <div className={styles.displayFlex}>
            <button type="button" className={styles.cancelBtn} onClick={() => navigate(-1)} >
              Back
            </button>
            <button type="submit" className={styles.submitBtn} disabled={loading}>
              {loading ? "loaing..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default PartList;
